import { render } from "./TodaysMatchScheduleList.vue?vue&type=template&id=7a68661c&ts=true"
import script from "./TodaysMatchScheduleList.vue?vue&type=script&lang=ts"
export * from "./TodaysMatchScheduleList.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__